import { Link } from '@tanstack/react-router';
import clsx from 'clsx';
import type { ReactNode } from 'react';

export type UserLinkProps = {
  userId: string;
  displayName?: string | null;
  email?: string | null;
  className?: string;
  children?: ReactNode;
};

export function UserLink({
  userId,
  displayName,
  email,
  className,
  children,
}: UserLinkProps) {
  const text = children ?? displayName ?? email ?? userId;

  return (
    <Link
      to="/admin/users/$userId"
      params={{ userId }}
      title={email ?? userId}
      className={clsx('font-medium text-nova-primary hover:underline', className)}
    >
      {text}
    </Link>
  );
}
